import { createRoot, useState,useEffect } from '@wordpress/element';

import { __ } from '@wordpress/i18n';
import { Provider } from 'react-redux';
import store from "../../vayu-sites/store";
import { useSelector, useDispatch } from 'react-redux';
import { getQueryArg } from '@wordpress/url';

import { VerifyKey } from '../../vayu-sites/template/verifykey';
import Header from './header';
import MainContent from './mainContent';

function MyPluginContent(){
    const dashboardTabActive = useSelector((state)=>state.dashboardTabActive);

// Upgrade 
    const verifyKeyCheck = VerifyKey();
    const [activeTab, setActiveTab] = useState('welcome');
    const [templateMode, setTemplateMode] = useState(true);

        useEffect(() => {
              const page = getQueryArg(window.location.href, 'page'); 
            handleTabClick(page);
    }, []);



    const removeClassAndAddCurrent = (num) => {
        const lis = document.querySelectorAll(".toplevel_page_vayu-blocks .wp-submenu li");
                        lis.forEach(li => li.classList.remove("current"));
        document.querySelectorAll(`.toplevel_page_vayu-blocks .wp-submenu li:nth-child(${num})`)
    .forEach((li) => li.classList.add("current"));
    }

    const handleTabClick = (tab) => {


        if (tab === 'blocks' || tab==='vayu-blocks-settings') {
            removeClassAndAddCurrent(3);
            setActiveTab('blocks');
            const newUrl = `${window.location.pathname}?page=vayu-blocks-settings`;
            window.history.pushState(null, null, newUrl);
        }else if(tab==='sites' || tab==='vayu-sites'){
                removeClassAndAddCurrent(4);
            setActiveTab('sites');
             const page = getQueryArg(window.location.href, 'template'); 
            
            const newUrl = `${window.location.pathname}?page=vayu-sites`;
             page !== 'step' && window.history.pushState(null, '', newUrl);
            page === 'step' && setTemplateMode(false);
        }else{
                removeClassAndAddCurrent(2);
          setActiveTab('welcome');
            const newUrl = `${window.location.pathname}?page=vayu-blocks`;
            window.history.pushState(null, null, newUrl);
        }
    };


// return data
    return (
        <>
        <div className="th-inner-wrap">    
        <Header activeTab={activeTab} handleTabClick={handleTabClick} template={templateMode} />
       <MainContent activeTab={activeTab} setActiveTab={setActiveTab} /> 
        </div>   
        </>
       
    );
}

const container = document.getElementById('vayu-blocks-container');
if (container) {
  // Use createRoot to create a root instance and then render the component
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
  <MyPluginContent />
  </Provider>
);
}